var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-col flex-align-center"},[_c('p',{staticClass:"text-h1"},[_vm._v("用户服务协议")]),_c('div',{staticClass:"main text",domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }